import {addClass, find, findAll, findID, listener, removeClass} from "../../../../../../../modules/vegas/js/util";
import VGCatalogOrder from "./order";
import VGCatalogCart from "../cart/cart";
import YandexMap from "../../ymap";

function listeners() {
	listener('change', '[name=delivery_id]', function (el, event) {
		event.preventDefault();

		let id = el.dataset.id,
			$containerOrder = el.closest('.cart-form'),
			$containerDelivery = find('.delivery-area--placement', $containerOrder),
			payments = el.dataset.payments.split(',')
		;

		let firstEnabledPayment = null;
		$containerOrder.querySelectorAll('[name=payment_id]').forEach((el) => {
			let enabled = payments.indexOf(el.value) !== -1;
			if (enabled) {
				if (!firstEnabledPayment) {
					firstEnabledPayment = el.value;
				}
				el.disabled = false;
			} else {
				el.disabled = true;
			}
		});
		let checkedPayment = $containerOrder.querySelector('[name=payment_id]:checked');
		if (checkedPayment && checkedPayment.disabled && firstEnabledPayment) {
			let radio = $containerOrder.querySelector(`[name=payment_id][value="${firstEnabledPayment}"]`)
			if (radio) radio.checked = true;
		}

		if ($containerDelivery) {
			// set show & active
			$containerDelivery.querySelectorAll('.active').forEach((el) => {
				el.classList.remove('show', 'active');
			})

			let $currentDelivery = $containerDelivery.querySelector(`[data-id="${id}"]`);
			if ($currentDelivery) {
				$currentDelivery.classList.add('show', 'active');
			}

			// use required
			findAll('.delivery-area--placement .toggle-required').forEach((el) => {
				el.removeAttribute('required');
			});
			let togglerCurrent = $currentDelivery.querySelector('.toggle-required');
			if (togglerCurrent) {
				togglerCurrent.setAttribute('required', 'required');
			}
		}

		new VGCatalogCart().update();
	});
}

function onReady() {
	let $formOrder = findID('form-cart'),
		order = new VGCatalogOrder();

	if (!$formOrder) return false;

	new YandexMap().include(() => {
		order.courier().init();
		order.update();
	});

	$formOrder.onsubmit = function () {
		let $cartPreload = find('.catalog-cart--preload');
		if (!$cartPreload) return false;

		addClass($cartPreload, 'show');

		order.make($formOrder, function (data) {
			if (data.error) {
				removeClass($cartPreload, 'show');
				alert(data.msg);
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	}

	$formOrder.onkeydown = function (event) {
		return event.key !== "Enter";
	}
}

document.addEventListener('DOMContentLoaded', onReady);
document.addEventListener('DOMContentLoaded', listeners);

if (window.Turbo !== 'undefined' && typeof onTurboRender === 'function') {
	onTurboRender(onReady);
}
